import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	setAds: (value: string) => void;
}

export const AdsField: React.FC<IProps> = React.memo(({ setAds }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAds') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			setAds(onlyDigits);
			return onlyDigits;
		},
		[setAds],
	);

	return (
		<FormInputNew
			testId="AdsField"
			name="ads"
			label="adsLabel"
			validationRules={validationRules}
			getValueFromEvent={handleChange}
		/>
	);
});
